import { SidebarItem } from "@/Store/sidebar-items";
import { i18n } from "@/i18n";

//sidebar: dashboard-item
const DashboardSidebarItemBuilder = () => new SidebarItem('dashboard', {
    title: i18n.t('app.sidebar_items.dashboard'),
    icon: 'mdi-home',
    route: 'dashboard',
});

//sidebar: data-gathering-item
const DataGatheringSidebarItemBuilder = () => new SidebarItem('data-sources', {
    title: i18n.t('app.sidebar_items.data_sources'),
    icon: 'mdi-poll',
    items: [
        {
            id: 'bibles',
            title: i18n.t('app.sidebar_items.bibles'),
            route: 'bibles.index',
            related_routes: ['bibles.records'],
        },
        {
            id: 'surveys',
            title: i18n.t('app.sidebar_items.surveys'),
            route: 'surveys.index',
            related_routes: ['surveys.records'],
        },
        {
            id: 'finished',
            title: i18n.t('app.sidebar_items.finished'),
            route: 'finished.index',
            related_routes: ['finished.records'],
        },
        {
            id: 'abandonment',
            title: i18n.t('app.sidebar_items.abandonment'),
            route: 'abandonment.index',
            related_routes: ['abandonment.records'],
        },
    ].map(item => new SidebarItem(item.id, item)),
});

//sidebar: indicators-item
const IndicatorsSidebarItemBuilder = () => new SidebarItem('indicators', {
    title: i18n.t('app.sidebar_items.indicators'),
    icon: 'mdi-chart-box',
    items: [
        {
            id: 'list',
            title: i18n.t('app.sidebar_items.list'),
            route: 'indicators.index',
            related_routes: ['indicators.index'],
            route_arguments: {
                type: 'generate',
            },
        },
        // {
        //     id: 'generate',
        //     title: i18n.t('app.sidebar_items.indicators_generate'),
        //     route: 'indicators.generate',
        //     related_routes: ['indicators.generate'],
        //     route_arguments: {
        //         type: 'generate',
        //     },
        // },
        // {
        //     id: 'index',
        //     title: i18n.t('app.sidebar_items.indicators_manage'),
        //     route: 'indicators.edit',
        //     disabled: true,
        //     touchless: true,
        //     related_routes: ['indicators.edit'],
        //     route_arguments: {
        //         type: 'manage',
        //     },
        // },
    ].map(item => new SidebarItem(`indicators.${item.id}`, item)),
});

//sidebar: reports-item
const ReportsSidebarItemBuilder = () => new SidebarItem('reports', {
    title: i18n.t('reports.reports'),
    icon: 'mdi-file-chart',
    items: [
        //sidebar, reports, performance
        // {
        //     id: 'performance',
        //     title: i18n.t('app.sidebar_items.reports_performance'),
        //     route: 'reports.index',
        //     route_arguments: {
        //         type: 'performance',
        //     },
        //     related_routes: [],
        // },
        //sidebar, reports, progress
        // {
        //     id: 'progress',
        //     title: i18n.t('app.sidebar_items.reports_progress'),
        //     route: 'reports.index',
        //     route_arguments: {
        //         type: 'progress',
        //     },
        //     related_routes: [],
        // },
        //sidebar, reports, income-mobility
        // {
        //     id: 'income-mobility',
        //     title: i18n.t('app.sidebar_items.reports_income_mobility'),
        //     route: 'reports.index',
        //     route_arguments: {
        //         type: 'income-mobility',
        //     },
        //     related_routes: [],
        // },
        //sidebar, reports, income-access
        // {
        //     id: 'income-access',
        //     title: i18n.t('app.sidebar_items.reports_income_access'),
        //     route: 'reports.index',
        //     route_arguments: {
        //         type: 'income-access',
        //     },
        //     related_routes: [],
        // },
        //sidebar, reports, statistical-report
        // {
        //     id: 'statistical-report',
        //     title: i18n.t('app.sidebar_items.reports_statistical_report'),
        //     route: 'reports.index',
        //     route_arguments: {
        //         type: 'statistical-report',
        //     },
        //     related_routes: [],
        // },
        //sidebar, reports, table-2
        {
            id: 'table-two',
            title: i18n.t('app.sidebar_items.reports_table_2'),
            route: 'reports.index',
            route_arguments: {
                type: 'table-two',
            },
            related_routes: [],
        },
        {
            id: 'statistical_report',
            title: i18n.t('app.sidebar_items.reports_statistical_report'),
            route: 'reports.index',
            route_arguments: {
                type: 'statistical-report',
            },
            related_routes: [],
        },
        // {
        //     id: 'academic_performance_report',
        //     title: i18n.t('app.sidebar_items.reports_performance'),
        //     route: 'reports.index',
        //     route_arguments: {
        //         type: 'statistical-report',
        //     },
        //     related_routes: [],
        // },
        //sidebar, reports, annual-degree-improvement-report
        {
            id: 'annual-degree-improvement',
            title: i18n.t('app.sidebar_items.reports_annual_degree_improvement_report'),
            route: 'reports.index',
            route_arguments: {
                type: 'annual-degree-improvement',
            },
            related_routes: [],
        },
        {
            id: 'access-and-admission-process',
            title: i18n.t('app.sidebar_items.access_and_admission_process'),
            route: 'reports.index',
            route_arguments: {
                type: 'access-and-admission-process',
            },
            related_routes: [],
        },
    ].map(item => new SidebarItem(`reports.${item.id}`, item))
});

const DocumentSidebarItemBuilder = () => new SidebarItem('documents', {
    title: i18n.t('app.sidebar_items.documents'),
    icon: 'mdi-google-drive',
    external_link: process.env.MIX_GOOGLE_DRIVE_DOCUMENTS
});

export default {
    all() {
        return [
            DashboardSidebarItemBuilder(),
            DataGatheringSidebarItemBuilder(),
            IndicatorsSidebarItemBuilder(),
            ReportsSidebarItemBuilder(),
            DocumentSidebarItemBuilder(),
        ];
    },
};
